import { Formik, Form, ErrorMessage } from 'formik';
import * as yup from 'yup';
import { $t } from 'hooks/i18n';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import { DataSource } from 'components/DataSource';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { PageRequestError } from 'components/PageRequestError';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Title } from 'components/Title';
import useApp from 'hooks/useApp';

import useEditPage from 'hooks/useEditPage';
const EmpmasterEditPage = (props) => {
		const app = useApp();
	// form validation schema
	const validationSchema = yup.object().shape({
		empcode: yup.string().required().label($t('empcode')),
		empname: yup.string().required().label($t('empname')),
		designation: yup.string().required().label($t('designation')),
		joiningdate: yup.string().nullable().label($t('joiningdate')),
		address1: yup.string().nullable().label($t('address1')),
		address2: yup.string().nullable().label($t('address2')),
		phone: yup.string().required().label($t('phone')),
		emailid: yup.string().email().nullable().label($t('emailid')),
		pancard: yup.string().nullable().label($t('pancard')),
		pancard_upload: yup.string().nullable().label($t('pancardUpload')),
		idcard_no: yup.string().nullable().label($t('idcardNo')),
		idcard_type: yup.string().nullable().label($t('idcardType')),
		idcard_upload: yup.string().nullable().label($t('idcardUpload')),
		idcard1_type: yup.string().nullable().label($t('idcard1Type')),
		idcard1_number: yup.string().nullable().label($t('idcard1Number')),
		idcard1_upload: yup.string().nullable().label($t('idcard1Upload')),
		other_docs: yup.string().nullable().label($t('otherDocs')),
		other_docs_upload: yup.string().nullable().label($t('otherDocsUpload'))
	});
	// form default values
	const formDefaultValues = {
		empcode: '', 
		empname: '', 
		designation: '', 
		joiningdate: new Date(), 
		address1: '', 
		address2: '', 
		phone: '', 
		emailid: '', 
		pancard: '', 
		pancard_upload: '', 
		idcard_no: '', 
		idcard_type: '', 
		idcard_upload: '', 
		idcard1_type: '', 
		idcard1_number: '', 
		idcard1_upload: '', 
		other_docs: '', 
		other_docs_upload: '', 
	}
	//where page logics resides
	const pageController = useEditPage({ props, formDefaultValues, afterSubmit });
	//destructure and grab what we need
	const { formData, handleSubmit, submitForm, pageReady, loading, saving, apiRequestError, inputClassName } = pageController
	//Event raised on form submit success
	function afterSubmit(response){
		app.flashMsg(props.msgTitle, props.msgAfterSave);
		if(app.isDialogOpen()){
			app.closeDialogs(); // if page is open as dialog, close dialog
		}
		else if(props.redirect) {
			app.navigate(`/empmaster`);
		}
	}
	// loading form data from api
	if(loading){
		return (
			<div className="p-3 text-center">
				<ProgressSpinner style={{width:'50px', height:'50px'}} />
			</div>
		);
	}
	//display error page 
	if(apiRequestError){
		return (
			<PageRequestError error={apiRequestError} />
		);
	}
	//page is ready when formdata loaded successfully
	if(pageReady){
		return (
<main id="EmpmasterEditPage" className="main-page">
    { (props.showHeader) && 
    <section className="page-section mb-3" >
        <div className="container">
            <div className="grid justify-content-between align-items-center">
                { !props.isSubPage && 
                <div className="col-fixed " >
                    <Button onClick={() => app.navigate(-1)} label={$t('')}  className="p-button p-button-text " icon="pi pi-arrow-left"  />
                </div>
                }
                <div className="col " >
                    <Title title={$t('editEmpmaster')}   titleClass="text-2xl text-primary font-bold" subTitleClass="text-500"      separator={false} />
                </div>
            </div>
        </div>
    </section>
    }
    <section className="page-section " >
        <div className="container">
            <div className="grid ">
                <div className="md:col-9 sm:col-12 comp-grid" >
                    <div >
                        <Formik
                            initialValues={formData}
                            validationSchema={validationSchema} 
                            onSubmit={(values, actions) => {
                            submitForm(values);
                            }
                            }
                            >
                            { (formik) => {
                            return (
                            <Form className={`${!props.isSubPage ? 'card  ' : ''}`}>
                                <div className="grid">
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('empcode')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="empcode"  onChange={formik.handleChange}  value={formik.values.empcode}   label={$t('empcode')} type="text" placeholder={$t('enterEmpcode')}        className={inputClassName(formik?.errors?.empcode)} />
                                                <ErrorMessage name="empcode" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('empname')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="empname"  onChange={formik.handleChange}  value={formik.values.empname}   label={$t('empname')} type="text" placeholder={$t('enterEmpname')}        className={inputClassName(formik?.errors?.empname)} />
                                                <ErrorMessage name="empname" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('designation')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <DataSource   apiPath="components_data/designation_option_list"  >
                                                    {
                                                    ({ response }) => 
                                                    <>
                                                    <Dropdown  name="designation"     optionLabel="label" optionValue="value" value={formik.values.designation} onChange={formik.handleChange} options={response} label={$t('designation')}  placeholder={$t('selectAValue')}  className={inputClassName(formik?.errors?.designation)}   />
                                                    <ErrorMessage name="designation" component="span" className="p-error" />
                                                    </>
                                                    }
                                                </DataSource>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('joiningdate')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <Calendar name="joiningdate" value={formik.values.joiningdate} onChange={formik.handleChange} showButtonBar showTime dateFormat="yy-mm-dd" hourFormat="24"showIcon className={inputClassName(formik?.errors?.joiningdate)}        />
                                                <ErrorMessage name="joiningdate" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('address1')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="address1"  onChange={formik.handleChange}  value={formik.values.address1}   label={$t('address1')} type="text" placeholder={$t('enterAddress1')}        className={inputClassName(formik?.errors?.address1)} />
                                                <ErrorMessage name="address1" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('address2')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="address2"  onChange={formik.handleChange}  value={formik.values.address2}   label={$t('address2')} type="text" placeholder={$t('enterAddress2')}        className={inputClassName(formik?.errors?.address2)} />
                                                <ErrorMessage name="address2" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('phone')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="phone"  onChange={formik.handleChange}  value={formik.values.phone}   label={$t('phone')} type="text" placeholder={$t('enterPhone')}        className={inputClassName(formik?.errors?.phone)} />
                                                <ErrorMessage name="phone" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('emailid')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="emailid"  onChange={formik.handleChange}  value={formik.values.emailid}   label={$t('emailid')} type="email" placeholder={$t('enterEmailid')}        className={inputClassName(formik?.errors?.emailid)} />
                                                <ErrorMessage name="emailid" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('pancard')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="pancard"  onChange={formik.handleChange}  value={formik.values.pancard}   label={$t('pancard')} type="text" placeholder={$t('enterPancard')}        className={inputClassName(formik?.errors?.pancard)} />
                                                <ErrorMessage name="pancard" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('pancardUpload')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="pancard_upload"  onChange={formik.handleChange}  value={formik.values.pancard_upload}   label={$t('pancardUpload')} type="text" placeholder={$t('enterPancardUpload')}        className={inputClassName(formik?.errors?.pancard_upload)} />
                                                <ErrorMessage name="pancard_upload" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('idcardNo')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="idcard_no"  onChange={formik.handleChange}  value={formik.values.idcard_no}   label={$t('idcardNo')} type="text" placeholder={$t('enterIdcardNo')}        className={inputClassName(formik?.errors?.idcard_no)} />
                                                <ErrorMessage name="idcard_no" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('idcardType')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="idcard_type"  onChange={formik.handleChange}  value={formik.values.idcard_type}   label={$t('idcardType')} type="text" placeholder={$t('enterIdcardType')}        className={inputClassName(formik?.errors?.idcard_type)} />
                                                <ErrorMessage name="idcard_type" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('idcardUpload')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="idcard_upload"  onChange={formik.handleChange}  value={formik.values.idcard_upload}   label={$t('idcardUpload')} type="text" placeholder={$t('enterIdcardUpload')}        className={inputClassName(formik?.errors?.idcard_upload)} />
                                                <ErrorMessage name="idcard_upload" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('idcard1Type')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="idcard1_type"  onChange={formik.handleChange}  value={formik.values.idcard1_type}   label={$t('idcard1Type')} type="text" placeholder={$t('enterIdcard1Type')}        className={inputClassName(formik?.errors?.idcard1_type)} />
                                                <ErrorMessage name="idcard1_type" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('idcard1Number')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="idcard1_number"  onChange={formik.handleChange}  value={formik.values.idcard1_number}   label={$t('idcard1Number')} type="text" placeholder={$t('enterIdcard1Number')}        className={inputClassName(formik?.errors?.idcard1_number)} />
                                                <ErrorMessage name="idcard1_number" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('idcard1Upload')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="idcard1_upload"  onChange={formik.handleChange}  value={formik.values.idcard1_upload}   label={$t('idcard1Upload')} type="text" placeholder={$t('enterIdcard1Upload')}        className={inputClassName(formik?.errors?.idcard1_upload)} />
                                                <ErrorMessage name="idcard1_upload" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('otherDocs')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="other_docs"  onChange={formik.handleChange}  value={formik.values.other_docs}   label={$t('otherDocs')} type="text" placeholder={$t('enterOtherDocs')}        className={inputClassName(formik?.errors?.other_docs)} />
                                                <ErrorMessage name="other_docs" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('otherDocsUpload')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="other_docs_upload"  onChange={formik.handleChange}  value={formik.values.other_docs_upload}   label={$t('otherDocsUpload')} type="text" placeholder={$t('enterOtherDocsUpload')}        className={inputClassName(formik?.errors?.other_docs_upload)} />
                                                <ErrorMessage name="other_docs_upload" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                { props.showFooter && 
                                <div className="text-center my-3">
                                    <Button onClick={(e) => handleSubmit(e, formik)}  type="submit" label={$t('update')} icon="pi pi-send" loading={saving} />
                                </div>
                                }
                            </Form>
                            );
                            }
                            }
                            </Formik>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </main>
		);
	}
}
EmpmasterEditPage.defaultProps = {
	primaryKey: 'empcode',
	pageName: 'empmaster',
	apiPath: 'empmaster/edit',
	routeName: 'empmasteredit',
	submitButtonLabel: $t('update'),
	formValidationError: $t('formIsInvalid'),
	formValidationMsg: $t('pleaseCompleteTheForm'),
	msgTitle: $t('updateRecord'),
	msgAfterSave: $t('recordUpdatedSuccessfully'),
	msgBeforeSave: $t(''),
	showHeader: true,
	showFooter: true,
	redirect: true,
	isSubPage: false
}
export default EmpmasterEditPage;
